import { UrlSegment } from '@angular/router';

import { urlSlashes } from './../../utils';


/**
 * Constructs the URL path based on the segemnets
 *
 * @param aSegments     the segments
 * @return the path
 */
function _getPathFromUrlSegments(aSegments: UrlSegment[]): string {
  // convert the segments
  return urlSlashes(aSegments.map(segment => encodeURIComponent(segment.path)).join('/'));
}

export {
  _getPathFromUrlSegments as pathGetPathFromUrlSegments
};
